module.exports = __webpack_public_path__ + "img/4.7d2286a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/4.png
// module id = bK8o
// module chunks = 1